import { ReactElement, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Modal } from "bootstrap";
import Navbar from "../components/Navbar";
import MobileBottomTabs from "../components/MobileBottomTabs";
import SepetPopup from "../popupPages/SepetPopup";
import { ILoginInfo } from "../models/ILoginInfo";
import { useActiveOrder } from "../utils/ActiveOrderContext";
// import ActiveOrderBar from "../components/ActiveOrderBar"; // polling versiyonu
import ActiveOrderBarSignalR from "../components/ActiveOrderBarSignalR";
import PullToRefresh from "../components/PullToRefresh";
import Footer from "../components/Footer";
import { LiveChatWidget } from "../modules/LiveChat";
import { getUserToken, logout } from "../utils/tokenUtils";
import { getCustomerDetailsByToken } from "../services/auth";

function Control(props: { item: ReactElement }) {
  const navigate = useNavigate();
  const userObj: ILoginInfo = {
    token: "",
    expiration: "",
    userId: "",
    secretKey: "",
    restourantId: "",
  };

  const { activeOrders, refreshActiveOrder } = useActiveOrder();

  const [searchParams, setSearchParams] = useSearchParams();

  const openLoginModal = () => {
    // Misafir + henüz şehir seçmemiş kullanıcıda Dashboard "Konumunuzu Seçin" popup'ını
    // zaten açacak; ikisi üst üste binmesin diye bu durumda login modal'ı açma.
    if (!getUserToken() && !localStorage.getItem("guestTownId")) return;
    const el = document.getElementById("loginModal");
    if (el) Modal.getOrCreateInstance(el).show();
  };

  useEffect(() => {
    refreshActiveOrder();
    if (getUserToken()) {
      getCustomerDetailsByToken().catch(() => {});
    }

    if (searchParams.get("showLogin") === "1") {
      searchParams.delete("showLogin");
      setSearchParams(searchParams, { replace: true });
      setTimeout(openLoginModal, 500);
    }

    const handleShowLogin = () => openLoginModal();
    window.addEventListener("show-login", handleShowLogin);
    return () => window.removeEventListener("show-login", handleShowLogin);
  }, []);

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Navbar user={userObj}></Navbar>
      <div style={{ flex: 1 }} className={`mobile-content-padding${activeOrders.length > 0 ? " mobile-order-bar-padding" : ""}`}>
        {props.item}
      </div>
      <div className="d-none d-sm-block">
        <Footer />
      </div>
      <SepetPopup onChangeAddress={() => navigate("/adreslerim")} />

      {/* <ActiveOrderBar /> */}{/* polling versiyonu */}
      <ActiveOrderBarSignalR />
      <PullToRefresh />
      <LiveChatWidget />
      <MobileBottomTabs
        loggedIn={!!getUserToken()}
        onLoginSuccess={() => window.location.reload()}
        onLogout={() => { logout(); window.location.href = "/"; }}
      />
    </div>
  );
}

export default Control;
